import React from 'react';
import {
  GoalSettingsConnectorApollo,
  GoalSettingsValidateConnectorApollo,
  SaveGoalSettingsConnectorApollo,
} from '@front-activerse/common-components';
import GoalSettingsContainer from './GoalSettingsContainer';
import { IRoute } from '@front-activerse/common-components';

interface IGoalSettingsPage {
  descendantRoutes: IRoute[];
}

const GoalSettingsIndexPage: React.FC<IGoalSettingsPage> = ({ descendantRoutes }) => {
  return (
    <GoalSettingsConnectorApollo>
      {({ ...goalSettingsData }) => (
        <SaveGoalSettingsConnectorApollo>
          {({ saveGoalSettings }) => (
            <GoalSettingsValidateConnectorApollo>
              {({ validateGoalSettings }) => (
                <GoalSettingsContainer
                  descendantRoutes={descendantRoutes}
                  {...goalSettingsData}
                  saveGoalSettings={saveGoalSettings}
                  validateGoalSettings={validateGoalSettings}
                />
              )}
            </GoalSettingsValidateConnectorApollo>
          )}
        </SaveGoalSettingsConnectorApollo>
      )}
    </GoalSettingsConnectorApollo>
  );
};

export default GoalSettingsIndexPage;
